import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { sendCertificateResolver } from '../server/resolver.js';

export const sendCertificate = registerMutation({
  operationName: 'sendCertificate',
  resolve: sendCertificateResolver,
  type: type => String,
  params: [
    { type: () => String, name: 'orderID' },
    { type: () => String, name: 'examDate' },
  ],
});
